import React from 'react';
import {Redirect,Route} from 'react-router-dom';
import jwt_decode from 'jwt-decode';
import { connect } from 'react-redux';
import Loader from '../../Helper/loader/loader';
import {routeName} from '../../Service/env';

const AccountRoute = ({...props})=>{
    const token = localStorage.getItem('token');
    let access
    let decoded;
    try {
        if (token === undefined) {
            access = false
        }
        else {
            decoded = jwt_decode(token)
        }
    } catch (err) {
        console.log(err);
    }
    let currentTime = Math.floor(Date.now()/1000);
    if(!decoded || !decoded.exp){
        localStorage.removeItem('token');
        access = false;
    }
    else
    {
        if (decoded.exp < currentTime) {
            access = false;
            localStorage.removeItem('user');
        }
        else {
            access = true;
        }
    }

    return (
        access ?
            (Object.keys(props.user).includes('Message')) ?
                props.user.IsBillable ?
                    props.user.IsSubscribe ?
                        !props.user.RedirectToOverview ?
                            <Route {...props} days={props.user.LastDaysToAccess}/>
                            :
                            <Route {...props} days={props.user.LastDaysToAccess}/>
                        :
                        <Redirect to={`/${routeName}/Payment`} />
                    :
                    <Route {...props}/>
                :
                <div className='no-data'><Loader/></div>
            : <div>
            <Redirect to={`/${routeName}`}/>
        </div>
    )
};
const mapStateToProps = state => {
    return{
        location:state.router.location
    }
};

export default connect(mapStateToProps,null)(AccountRoute);